import React from 'react'
import TodayIcon from '@mui/icons-material/Today';
import { DateTime } from 'luxon';
import { ReactComponent as Plus } from "../../assets/new-icons/plus.svg";
import { ReactComponent as Canone } from "../../assets/new-icons/canone.svg";
import { ReactComponent as Incasso } from "../../assets/new-icons/bank2.svg";
import { ReactComponent as Check } from "../../assets/new-icons/check_simple.svg";
import { ReactComponent as Cuore } from "../../assets/new-icons/cuore.svg";
import { ReactComponent as Euro } from "../../assets/new-icons/euro.svg";
import { ReactComponent as Assistenza } from "../../assets/new-icons/assistenza.svg";
import { ReactComponent as Whatsapp } from "../../assets/new-icons/whatsapp.svg";
import { ReactComponent as QuestionIcon } from "../../assets/new-icons/question.svg";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import DownloadIcon from "@mui/icons-material/Download";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function MovimentoDettaglio(props) {
    const navigate = useNavigate()
    const fullName = useSelector((user) => user.user.info.customer_full_heading)
    const userNameWords = fullName.split(' ').length;
    const splittedName = userNameWords < 3 ? fullName.split(' ').slice(0, -1).join(' ') : fullName.split(' ').slice(0, -2).join(' ')
    const splittedNameLower = splittedName
    const customerCode = useSelector((user) => user.user.info.customer_code);
    const { reason, amount, data_emissione, tag, entry_price, entry_kwh, note, url_fattura, url_fattura_canone, entry_id } = props.details
    const urlWhatsapp = `https://wa.me/393935777481?text=Ciao%20sono%20${splittedNameLower},%20${customerCode}.%20Ti%20contatto%20in%20merito%20al%20movimento%20ID:%20${entry_id}`
    const idGruppo = useSelector((user) => user.user.idGruppo)
    const taglia = useSelector((user) => user.user.importo_taglia)
    const soglia = useSelector((user) => user.user.importo_soglia)

    console.log(props.details)
    const switchColor = () => {
        switch (tag) {
            case 'ricarica':
                return '#FF7D57'
            case 'consumi':
                return '#19C1FF'
            case 'canone-rai':
                return '#FFD300'
            case 'incasso-sdd':
                return '#697386'
            default:
                return '#4F29A8';
        }
    }
    const switchIcon = () => {
        switch (tag) {
            case 'ricarica':
                return <Plus />
            case 'canone-rai':
                return <Canone />
            case 'incasso-sdd':
                return <Incasso />
            case 'ricariche-bonus':
                return <Cuore />
            case 'bonus-sociale':
                return <Cuore />
            case 'consumi':
                return <Euro />
            default:
                break;
        }
    }

    const switchDescription = () => {
        switch (tag) {
            case 'consumi': 
                return 'Ecco il dettaglio per il movimento richiesto. Se hai bisogno di ulteriori informazioni utilizza i pulsanti in basso o contatta il Servizio Clienti.'
            case 'bonus-sociale':
                return "Questo è l'importo del bonus sociale per la mensilità di riferimento. Ti ricordiamo che gli importi ci vengono comunicati direttamente dall'Acquirente Unico."
            case 'canone-rai':
                return "Questo è l'importo relativo al Canone TV per la mensilità di riferimento. Ti ricordiamo che tutti gli importi ci vengono comunicati direttamente dall'Agenzia delle Entrate."
            default:
                return 'Ecco il dettaglio per il movimento richiesto. Se hai bisogno di ulteriori informazioni utilizza i pulsanti in basso o contatta il Servizio Clienti.'
        }
    }
    return (
        <div className='movimentiDettaglio'>
            <div className="detailsTop">
                <div className="date">
                    <TodayIcon />
                    <p className='main'>
                        {DateTime.fromISO(data_emissione).toFormat("D")}
                    </p>
                </div>
                <div className="icon">
                    <i style={{ backgroundColor: switchColor() }}></i>
                    {switchIcon()}
                </div>
            </div>
            <p className="amount">
                {amount.toString().includes('-') ? parseFloat(amount).toFixed(2).replace(/\./g, ",") : `+ ${parseFloat(amount).toFixed(2).replace(/\./g, ",")}`} €
            </p>
            <p className='reason'>
                {reason}
            </p>
            <p className='description'>
                {switchDescription()}
            </p>
            {tag === 'consumi' ? (
                <div className="priceContainer">
                    <div className="entry_price">
                        <p className='label'>Prezzo</p>
                        <p className='value'>{parseFloat(entry_price).toFixed(2).replace(/\./g, ',')} <span className="currency">€/kWh</span></p>
                    </div>
                    <div className="empty"></div>
                    <div className="entry_kwh">
                        <p className='label'>Consumi</p>
                        <p className='value'>{entry_kwh.toString().replace('-', '')} <span className="currency">kW</span></p>
                    </div>
                </div>
            ) : null}
            {tag === 'oneri-diversi' || tag === 'canone-rai' || tag === 'consumi' ? (
                <div className="invoice">
                    <div className="icon">
                        <Check />
                    </div>
                    <div className="text">
                        <p className="date">{DateTime.fromISO(data_emissione).toFormat("D")}</p>
                        <div className="mainPrice">
                            <p className="main">{reason}</p>
                            <p className="note">
                                {note}
                            </p>
                        </div>
                    </div>
                    <div className="download" onClick={() => window.open(
                        url_fattura || url_fattura_canone,
                        "_blank"
                    )}>
                        <DownloadIcon />
                        <p>Scarica</p>
                    </div>
                </div>
            ) : null}
            {tag === 'ricarica' ? (
                <div className="ricaricaDetail">
                    <div className="flex">
                        <div className="icon">
                            <QuestionIcon />
                        </div>
                        <div className="text">
                            <p className="main">Perché questo movimento?</p>
                            {idGruppo === 1 ? (
                                <p className="note">Hai impostato Taglia di {parseFloat(taglia).toFixed(2).replace(/\./g, ",")} € e Soglia di {parseFloat(soglia).toFixed(2).replace(/\./g, ",")} €.</p>
                            ) : null}
                        </div>
                    </div>
                    { idGruppo === 1 ? (
                        <>
                            <div className="flex space">
                                <div className="box">
                                    <p>Soglia: </p>
                                    <p className="amount">
                                        {parseFloat(soglia).toFixed(2).replace(/\./g, ",")} €
                                    </p>
                                </div>
                                <div className="box">
                                    <p>Taglia: </p>
                                    <p className="amount">
                                        {parseFloat(taglia).toFixed(2).replace(/\./g, ",")} €
                                    </p>
                                </div>
                            </div>
                            <div className="flex right modifica" onClick={() => navigate('/enrica/fai-da-te/soglia-taglia')}>
                                <p>Modifica Taglia e Soglia</p>
                                <ArrowForwardIosIcon />
                            </div>
                        </>
                    ) : null}
                </div>
            ) : null}
            <div className="help">
                <div className="item" onClick={() => window.open(urlWhatsapp)}>
                     <Whatsapp className="whatsapp" />
                    <p>Chiedi info sul movimento</p>
                    <ArrowForwardIosIcon />
                </div>
                <div className="item" onClick={() => window.open('https://revoluce.zendesk.com/hc/it', { target: '_blank'})}>
                    <Assistenza />
                    <p>Cerca sull'help desk</p>
                    <ArrowForwardIosIcon />
                    
                </div>
            </div>
        </div>
    )
}

export default MovimentoDettaglio